import {Component, Injector, OnInit} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {AdminService} from "../dashboard/services/admin.service";
import {ParameterService} from "../../_services/parameter.service";
import {UserManagementMessage} from "./services/user-management.message";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {AdminUserAdvanceSearchDialog} from "./modals/admin-user-advance-search.dialog";

@Component({
    selector: 'admin-user-management',
    templateUrl: './user-management.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class UserManagementComponent extends BasePageComponentDirective<any> implements OnInit {
    users: any[] = [];

    ticketStatus: any = {};
    filterTotal = 0;
    userRoles: any[] = [];
    products: any[] = [];

    constructor(
        injector: Injector,
        private adminService: AdminService,
        private parameterService: ParameterService,
        private userMsg: UserManagementMessage,
    ) {
        super(injector);
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.ticketStatus = await this.parameterService.getParameterByName("TICKET_STATUS");
        this.query();
        this.userRoles = await this.adminService.getAllUserRoles();
        this.products = await this.adminService.getAllProducts();
    }

    query(): void {
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';

        this.pageQuery.columns = ['fullName', 'email'];
        this.adminService.getAllUsers(this.pageQuery).then(r => {
            this.users = r.content;
            for(let i = 0; i < this.users.length; i++) {
                this.users[i]['role'] = this.users[i].roles.map((r: { name: any; }) => r.name).join(', ')
            }

            this.page.emit(r);
        });
    }

    clearFilters() {
        this.pageQuery.filters = null;
        this.searchTerm = this.pageQuery.search;
        this.filterTotal = this.countFilters(this.pageQuery.filters);
        this.query();
    }

    openAdvanceSearch(): void {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '500px';
        const dialog = this.dialog.open(AdminUserAdvanceSearchDialog, {
            data: {
                userRoles: this.userRoles,
                products: this.products,
                pageQuery: this.pageQuery,
                theme: 'dark'
            },
            width: dialogWidth,
            maxWidth: '100%'
        });
        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                r.pageQuery = undefined;
                this.pageQuery.filters = r;
                this.filters = r;
                this.pageQuery.page = 0;
                this.filterTotal = this.countFilters(this.pageQuery.filters);
                this.query();
            }
        });
    }

    countFilters(filters: any): number {
        let i = 0;
        if(filters) {
            if(filters.accountType) i++;
            if(filters.roles) i++;
            if(filters.createDate) i++
        }

        return i;
    }

    searchUser($event: any) {
        if ($event.key === 'Enter') {
            this.filterTotal = this.countFilters(this.pageQuery.filters);
            this.searchTerm = this.pageQuery.search;
            this.query();
        }
    }

    editUser(user: any) {
        this.userMsg.changeMessage(user);
        this.router.navigate(['/office/user/' + user.id + '/editor']).then();
    }

    deleteUser(user: any) {
        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                message: `Are you sure want to delete this user ${user.fullName} (${user.email}) ?`,
                subMessage: 'Deleted user will stay in users list and can be restored later',
                buttonCancelLabel: 'Cancel',
                buttonOkLabel: 'Yes, Delete',
                theme: 'dark'
            }
        });

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.adminService.enableDisableUser({
                    key: user.id.toString(),
                    value: 'disabled'
                }).then(_ => {
                    this.showAlertDark('User Deletion', '', 'User has been deleted successfully!');
                    this.query();
                })
            }
        })
    }

    restoreUser(user: any) {
        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                message: `Are you sure want to restore this user ${user.fullName} (${user.email}) ?`,
                subMessage: 'Restored user will regain access to CertWallet app',
                buttonCancelLabel: 'Cancel',
                buttonOkLabel: 'Yes, Restore',
                theme: 'dark'
            }
        });

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.adminService.enableDisableUser({
                    key: user.id.toString(),
                    value: 'enabled'
                }).then(_ => {
                    this.showAlertDark('User Restoration', '', 'User has been restored successfully!');
                    this.query();
                })
            }
        })
    }

    checkAdmin(i: any) {
        let role = i.roles.find((r: { name: string; }) => r.name === 'ROLE_ADMIN');
        return !!role;

    }

    makeAdmin(user: any) {
        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                message: `Are you sure want to set this user ${user.fullName} (${user.email}) with Admin role?`,
                subMessage: 'Set user as administrator will make user to be able access to CertWallet app backoffice page',
                buttonCancelLabel: 'Cancel',
                buttonOkLabel: 'Yes, Make Admin',
                theme: 'dark'
            }
        });

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.adminService.makeAdmin({
                    key: user.id.toString(),
                    value: 'enabled'
                }).then(_ => {
                    this.showAlertDark('User Role', '', 'User has been set as administrator successfully!');
                    this.query();
                })
            }
        })
    }

    revokeAdmin(user: any) {
        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                message: `Are you sure want to revoke administrator role for this user ${user.fullName} (${user.email}) ?`,
                subMessage: 'Revoking user as administrator will make user unable to access to CertWallet app backoffice page',
                buttonCancelLabel: 'Cancel',
                buttonOkLabel: 'Yes, Revoke Admin',
                theme: 'dark'
            }
        });

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.adminService.revokeAdmin({
                    key: user.id.toString(),
                    value: 'enabled'
                }).then(_ => {
                    this.showAlertDark('User Role', '', 'User has been revoked from role administrator successfully!');
                    this.query();
                })
            }
        })
    }

}
